import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import StyledSelect from 'components/ui/StyledSelect';

const StyledDropdown = styled(StyledSelect)`
  display: block;
  height: 32px;
  margin-top: 0px;
`;

const StyledTextArea = styled.textarea`
  display: block;
  resize: none;
`;

const StyledLabel = styled.label`
  display: block;
  margin-top: 16px;

  ${ifProp(
    'danger',
    css`
      color: red;
    `
  )}
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  width: 100%;

  button {
    width: 250px;
    &:nth-child(2) {
      margin-left: 20px;
    }
  }
`;

export { StyledDropdown, StyledTextArea, StyledLabel, StyledButtonWrapper };
